module.exports = __webpack_public_path__ + "static/img/Scott.Gumbleton.57131e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Scott.Gumbleton.jpg
// module id = jeIe
// module chunks = 0